export default __webpack_public_path__ + "static/media/KOD0078-min.50580396.webp";